import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiPaginationResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import { FetchEecsFeesPayload, IEecsFee } from '../types/eecs-fees.types';

export const eecsFeesApi = createApi({
  reducerPath: 'eecsFeesApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/eecs/platform-fees`),
  endpoints: (builder) => ({
    fetchFees: builder.query<ApiPaginationResponse<IEecsFee[]>, FetchEecsFeesPayload>({
      query: (payload) => ({
        url: ``,
        method: 'GET',
        params: payload,
      }),
    }),
  }),
});

export const { useLazyFetchFeesQuery } = eecsFeesApi;
